module.exports = __webpack_public_path__ + "img/zhuanpan_small.7bf996a0.png";